import { MilestoneTemplateInput } from "@/components";
import { GUTTER_SIZE } from "@/enums";
import {
  milestoneTemplateType,
  projectMilestoneTemplateType,
} from "@/propTypes";
import { Col, Row } from "antd";
import { arrayOf, bool, func, oneOfType, shape, string } from "prop-types";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import * as GlobalS from "../styled";
import * as S from "./styled";

const NameAndAbbreviationEditor = ({
  setIsFormValid,
  milestoneTemplate,
  setMilestoneTemplate,
  comparisonMilestones,
}) => {
  const intl = useIntl();
  const [isDuplicateName, setIsDuplicateName] = useState(false);
  const [isDuplicateAbbreviation, setIsDuplicateAbbreviation] = useState(false);

  useEffect(() => {
    const validationCheck =
      !isDuplicateName &&
      !isDuplicateAbbreviation &&
      !!milestoneTemplate?.Name &&
      !!milestoneTemplate?.Abbreviation;
    setIsFormValid(validationCheck);
  }, [
    isDuplicateAbbreviation,
    isDuplicateName,
    milestoneTemplate?.Abbreviation,
    milestoneTemplate?.Name,
    setIsFormValid,
  ]);

  return (
    <S.MilestoneTemplateLayoutCard
      title={intl.formatMessage({
        id: "milestoneTemplates.nameAbbreviationLabel",
      })}
    >
      <GlobalS.CardBody>
        <Row gutter={GUTTER_SIZE.large}>
          <Col xs={18} style={{ maxWidth: "275px" }}>
            <MilestoneTemplateInput
              milestoneTemplate={milestoneTemplate}
              setMilestoneTemplate={setMilestoneTemplate}
              setIsDuplicateForValidationCheck={setIsDuplicateName}
              property={"Name"}
              comparisonMilestones={comparisonMilestones}
            />
          </Col>
          <Col xs={6} style={{ maxWidth: "110px" }}>
            <MilestoneTemplateInput
              milestoneTemplate={milestoneTemplate}
              setMilestoneTemplate={setMilestoneTemplate}
              setIsDuplicateForValidationCheck={setIsDuplicateAbbreviation}
              property={"Abbreviation"}
              comparisonMilestones={comparisonMilestones}
            />
          </Col>
        </Row>
      </GlobalS.CardBody>
    </S.MilestoneTemplateLayoutCard>
  );
};

NameAndAbbreviationEditor.propTypes = {
  milestoneTemplate: oneOfType([
    milestoneTemplateType,
    projectMilestoneTemplateType,
  ]),
  setMilestoneTemplate: func.isRequired,
  setIsFormValid: func.isRequired,
  readOnly: bool,
  comparisonMilestones: arrayOf(
    shape({
      id: string,
      Name: string,
      Abbreviation: string,
    })
  ),
};

export default NameAndAbbreviationEditor;
